import React from "react";
import { css, useTheme } from "@emotion/react";

import Image from "core/Components/Image";

type Props = {
    imageUrl: string|null,
    itemBoxImageWidth: number,
    itemBoxImageHeight: number,
    onClick: () => any,
};

const ItemImage: React.FC<Props> = (
    {
        imageUrl,
        itemBoxImageWidth,
        itemBoxImageHeight,
        onClick,
    }
) => {
    const theme = useTheme();

    const style = css`
        width: ${itemBoxImageWidth}px;
        height: ${itemBoxImageHeight}px;
        flex-shrink: 0;
        border-radius: 12px 0 0 12px;
        cursor: pointer;

        ${theme.breakpoints.down('xs')} {
            border-radius: 12px;
        }
    `;

    return (
        <div css={style} onClick={onClick}>
            {imageUrl ? (
                <Image image={imageUrl} useFocusPoint />
            ) : null}
        </div>
    );
};

export default ItemImage;